import api from '@api'
import {
  buildRelationalQualificationStructure,
  buildFlatQualificationStructure,
} from '@data/qualification'

const getQualifications = (filters) => {
  const qualDetails = []
  if ('id' in filters) {
    qualDetails.push(
      buildRelationalQualificationStructure(
        'managerId',
        'equal',
        filters.id,
        'long',
        'db'
      )
    )
  }
  return qualDetails
}

export function getTeamUsersApi(filters, searchCriterias, limit, offset) {
  const qualDetails = [
    ...((searchCriterias || {}).quals || []),
    ...getQualifications(filters),
  ]
  return api
    .post(
      `/user/search/byqual`,
      {
        qualDetails: qualDetails.length
          ? buildFlatQualificationStructure(qualDetails)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: data.objectList
          ? (data.objectList || []).map(transformUserForList)
          : [],
        total: data.totalCount,
      }
    })
}

const transformUserForList = (user) => {
  return {
    id: user.id,
    name: user.name,
    managerId: user.managerId,
    email: user.email,
    contactNo: user.contactNo,
    userType: user.userType,
  }
}
